import { useCallback, useEffect, useRef } from 'react';

// Delays `callback`; the pending call is dropped when the component unmounts.
export const useDebouncedCallback = (callback, delayMs) => {
  const timer = useRef(null);
  const latest = useRef(callback);
  latest.current = callback;

  useEffect(() => () => clearTimeout(timer.current), []);

  return useCallback(
    (...args) => {
      clearTimeout(timer.current);
      timer.current = setTimeout(() => latest.current(...args), delayMs);
    },
    [delayMs]
  );
};
